(function() { module.exports = window["Vue"]; }());